import React from "react";

const BTN_BASE = {
  flex: 1,
  height: 40,
  border: "none",
  borderRadius: 8,
  fontFamily: "'PingFang SC', sans-serif",
  fontWeight: 500,
  fontSize: 14,
  lineHeight: "22px",
  cursor: "pointer",
  WebkitAppearance: "none",
  appearance: "none",
};

/**
 * 跟单成功弹窗底部：OK + My Orders 并排
 */
export default function FollowSuccessModalActions({ t, onOk, onMyOrders }) {
  return (
    <div style={{ display: "flex", gap: 12, width: "100%" }}>
      <button
        type="button"
        style={{
          ...BTN_BASE,
          background: "#2b2e33",
          color: "#ffffff",
        }}
        onClick={onOk}
      >
        {t("aicopy.ok")}
      </button>
      <button
        type="button"
        style={{
          ...BTN_BASE,
          background: "#b9f78a",
          color: "#181a20",
        }}
        onClick={onMyOrders}
      >
        {t("aicopy.myOrders")}
      </button>
    </div>
  );
}
